import { render, staticRenderFns } from "./HeaderDefault.vue?vue&type=template&id=a1d0ef8c&"
import script from "./HeaderDefault.js?vue&type=script&lang=js&"
export * from "./HeaderDefault.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports